import { useEffect, useState } from "react";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { requestLastPersonalGoalWinners } from "@/apps/goals/services/goalsApi";
import { GoalWinner } from "@/apps/goals/types";

export const useGoalWinners = (regionGroupId?: number | null) => {
  const initData = useGoalsStore((state) => state.initData);
  const carCategory = initData?.program?.car_category || 'Не определено';

  const [winners, setWinners] = useState<GoalWinner[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (regionGroupId == null) {
      setWinners([]);
      setIsLoading(false);
      return;
    }

    let ignoreResult = false;
    setIsLoading(true);

    requestLastPersonalGoalWinners(regionGroupId, carCategory)
      .then((nextWinners) => {
        if (ignoreResult) return;

        setWinners(nextWinners);
        setIsLoading(false);
      })
      .catch(() => {
        if (ignoreResult) return;

        setWinners([]);
        setIsLoading(false);
      });

    return () => {
      ignoreResult = true;
    };
  }, [regionGroupId]);

  return { winners, isLoading };
};
